(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bodd-size-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-bodd-chart-unit]');
    const chart = toggle?.closest('.bodd-size-picker__chart');
    if (!toggle || !chart) return;
    const unit = toggle.getAttribute('data-bodd-chart-unit');
    chart.querySelectorAll('[data-bodd-chart-unit]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === toggle));
    });
    chart.querySelectorAll('td[data-value]').forEach((cell) => {
      const original = cell.getAttribute('data-value') || '';
      if (unit === 'in') { cell.textContent = original; return; }
      const parts = original.split(/\s*[-–]\s*/);
      if (!parts.every((part) => /^\d+(?:\.\d+)?$/.test(part))) return;
      cell.textContent = parts.map((part) => Math.round(Number(part) * 2.54 * 10) / 10).join(' - ');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
